var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#F6F6F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C12.6421 16 16 12.6421 16 8.5ZM17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5Z",
    fill: "#20242A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.4951 8.29981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.2002C0.776142 3.2002 1 3.42405 1 3.7002V6.90039C0.999894 7.17644 0.776077 7.40039 0.5 7.40039C0.223923 7.40039 0.000105628 7.17644 0 6.90039V3.7002C0 3.42405 0.223858 3.2002 0.5 3.2002ZM0.509766 0C0.785847 0 1.00967 0.223942 1.00977 0.5C1.00977 0.776142 0.785908 1 0.509766 1H0.5C0.223858 1 0 0.776142 0 0.5C9.89314e-05 0.223942 0.223919 0 0.5 0H0.509766Z",
    fill: "#20242A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletInfoIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-info-icon.de57e458aeece61e06ead98a56a64ddc.svg";
export { ForwardRef as ReactComponent };